export const selectImageByType = (type: string) => {
  switch (type) {
    case 'order':
      return './assets/images/notifications/file.svg';
    case 'appeal':
      return './assets/images/notifications/help.svg';
    case 'payment':
      return './assets/images/notifications/money.svg';
    case 'news':
      return './assets/images/notifications/newspaper.svg';
    case 'meeting':
      return './assets/images/notifications/headphones.svg';
    // default icon is headphones because at the moment only meetings are access in personal cabinet
    default:
      return './assets/images/notifications/headphones.svg';
  }
};
